import { render, staticRenderFns } from "./CheckSizeView.vue?vue&type=template&id=672c5166&scoped=true"
import script from "./CheckSizeView.vue?vue&type=script&lang=js"
export * from "./CheckSizeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c5166",
  null
  
)

export default component.exports